import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TermsAndConditionsPDF from './terms-and-conditions2025.pdf';


const TermsAndConditionsModal = (props) => {

    const useStyles = makeStyles((theme) => ({
        dialogContent: {
          padding: 0,
          '& iframe': {
            width: '100%', // Ensure iframe takes full width
            height: '80vh', // Maintain height
            border: 'none', // Remove border
            display: 'block', // Prevent inline spacing issues
          },
        },
      }));

      const classes = useStyles();

   //-----Designation Modal close button toggle-----//
 
   return (

     <Dialog
      open={props.isOpen}
      onClose={()=> props.toggleTandC(false)}
      maxWidth="lg"
      fullWidth
      aria-labelledby="terms-and-conditions-dialog-title"
    >
      <DialogTitle id="terms-and-conditions-dialog-title">Terms and Conditions</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <iframe
          src={'https://terms-and-conditions-phishcloud.s3.us-west-2.amazonaws.com/PhishCloud+Terms+of+Service+2025.pdf'}
          title="Terms and Conditions PDF"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={()=> props.toggleTandC(false)} variant="contained" color="primary" style={{ backgroundColor: "#0055a2"}}>
          Close
        </Button>
      </DialogActions>
    </Dialog>

   );
 };
export default TermsAndConditionsModal;
